import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useI18n from '@i18n';
import { ITransactionsCard } from '@pages/statistics/transactions/interfaces';

const iconColors = {
    blue: '#0EA5E9',
    yellow: 'rgba(255, 203, 102, 0.5)',
    green: '#22C55E',
    red: '#F87171',
};

const iconWrapColors = {
    blue: 'rgba(230,246,255, 0.1)',
    yellow: 'rgba(255,203,102, 0.1)',
    green: 'rgba(50,208,118, 0.1)',
    red: 'rgba(255, 102, 102, 0.1)',
};
const Card: React.FC<{ card: ITransactionsCard }> = ({ card }) => {
    const { t } = useI18n('Transactions');
    const { label, iconColor, icon, count, commission } = card;

    return (
        <div
            className="flex flex-col w-full px-3 py-4 mr-4 bg-white shadow-2 rounded-2 hack-min-w-128px last:mr-0 xs:py-4 sm:mr-8 sm:last:mr-0 lg:flex-wrap lg:py-6 lg:px-4 xl:px-8"
            key={label}
        >
            <div className="flex flex-col items-center mb-1 sm:mb-2 sm:flex-row">
                <div
                    className="flex items-center justify-center w-6 h-6 rounded-full sm:mr-2"
                    style={{ backgroundColor: iconWrapColors[iconColor] }}
                >
                    <FontAwesomeIcon style={{ color: iconColors[iconColor] }} icon={icon} />
                </div>
                <div className="text-blueGray-300 text-p3 sm:text-p1">{t(label)}</div>
            </div>
            <div className="font-medium text-center text-blueGray-800 text-p3 sm:text-p2 sm:text-left sm:text-sub lg:w-full">
                <div>{count}</div>
                <div>({commission})</div>
            </div>
        </div>
    );
};

export default Card;
